/* tslint:disable */
/* eslint-disable */
/**
 * Microtech partes API
 * API Library for SmartyBar application
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
/**
 * FichajesApi - axios parameter creator
 * @export
 */
export const FichajesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns a fichaje by key
         * @param {string} key The key send by email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fichajeKeyGet: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            if (key === null || key === undefined) {
                throw new RequiredError('key','Required parameter key was null or undefined when calling fichajeKeyGet.');
            }
            const localVarPath = `/fichaje/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create a bew fichaje
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fichajePost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/fichajes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a list of fichajes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fichajesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/fichajes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },

        fichajeGetDocuments: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/fichajes/${id}/documents`;

            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;

            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },

        fichajeUploadDocuments: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/fichajes/${id}/documents`;

            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;

            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        downloadDocument: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/fichajes/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;

            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FichajesApi - functional programming interface
 * @export
 */
export const FichajesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns a fichaje by key
         * @param {string} key The key send by email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fichajeKeyGet(key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<any>> {
            const localVarAxiosArgs = await FichajesApiAxiosParamCreator(configuration).fichajeKeyGet(key, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs).catch((error) => {
                    configuration?.catchError(error);
                });;
            };
        },
        /**
         * 
         * @summary create a bew fichaje
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fichajePost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<any>> {
            const localVarAxiosArgs = await FichajesApiAxiosParamCreator(configuration).fichajePost(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs).catch((error) => {
                    configuration?.catchError(error);
                });;
            };
        },
        /**
         * 
         * @summary Returns a list of fichajes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fichajesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<any>> {
            const localVarAxiosArgs = await FichajesApiAxiosParamCreator(configuration).fichajesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs).catch((error) => {
                    configuration?.catchError(error);
                });;
            };
        },

        

        async fichajeGetDocuments(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<any>> {
            const localVarAxiosArgs = await FichajesApiAxiosParamCreator(configuration).fichajeGetDocuments(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs).catch((error) => {
                    configuration?.catchError(error);
                });;
            };
        },
        async fichajeUploadDocuments(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<any>> {
            const localVarAxiosArgs = await FichajesApiAxiosParamCreator(configuration).fichajeUploadDocuments(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs).catch((error) => {
                    configuration?.catchError(error);
                });;
            };
        },
        async downloadDocument(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<any>> {
            const localVarAxiosArgs = await FichajesApiAxiosParamCreator(configuration).downloadDocument(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs).catch((error) => {
                    configuration?.catchError(error);
                });;
            };
        },
    }
};

/**
 * FichajesApi - factory interface
 * @export
 */
export const FichajesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Returns a fichaje by key
         * @param {string} key The key send by email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fichajeKeyGet(key: string, options?: AxiosRequestConfig): Promise<any> {
            return FichajesApiFp(configuration).fichajeKeyGet(key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create a bew fichaje
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fichajePost(options?: AxiosRequestConfig): Promise<any> {
            return FichajesApiFp(configuration).fichajePost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns a list of fichajes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fichajesGet(options?: AxiosRequestConfig): Promise<any> {
            return FichajesApiFp(configuration).fichajesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FichajesApi - object-oriented interface
 * @export
 * @class FichajesApi
 * @extends {BaseAPI}
 */
export class FichajesApi extends BaseAPI {
    /**
     * 
     * @summary Returns a fichaje by key
     * @param {string} key The key send by email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FichajesApi
     */
    public async fichajeKeyGet(key: string, options?: AxiosRequestConfig) : Promise<any> {
        return FichajesApiFp(this.configuration).fichajeKeyGet(key, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary create a bew fichaje
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FichajesApi
     */
    public async fichajePost(options?: AxiosRequestConfig) : Promise<any> {
        return FichajesApiFp(this.configuration).fichajePost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns a list of fichajes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FichajesApi
     */
    public async fichajesGet(options?: AxiosRequestConfig) : Promise<any> {
        return FichajesApiFp(this.configuration).fichajesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns a list of fichajes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FichajesApi
     */
    public async fichajeGetDocuments(id: number, options?: AxiosRequestConfig) : Promise<any> {
        return FichajesApiFp(this.configuration).fichajeGetDocuments(id, options).then((request) => request(this.axios, this.basePath));
    }

    public async fichajeUploadDocuments(id: number, options?: AxiosRequestConfig) : Promise<any> {
        return FichajesApiFp(this.configuration).fichajeUploadDocuments(id, options).then((request) => request(this.axios, this.basePath));
    }

    public async downloadDocument(options?: AxiosRequestConfig) : Promise<any> {
        return FichajesApiFp(this.configuration).downloadDocument(options).then((request) => request(this.axios, this.basePath));
    }
}
